import CryptoJS from "crypto-js"

export function convertDateTime(d) {
  const year = d.getFullYear();
  const month = (d.getMonth() + 1).toString().padStart(2, '0')
  const day = d.getDate().toString().padStart(2, '0')
  const hours = d.getHours().toString().padStart(2, '0')
  const minutes = d.getMinutes().toString().padStart(2, '0')

  return `${year}-${month}-${day} ${hours}:${minutes}`
}

export function getLogString(x) {
  const encrypted = CryptoJS.AES.encrypt(x, process.env.VUE_APP_LOGGING_KEY).toString();
  return encrypted
}